module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('div', {
    staticClass: "fl p-r-10 bor-r-ccc",
    staticStyle: {
      "width": "55%"
    }
  }, [_c('div', {
    staticClass: "fr m-b-10"
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "placeholder": "控件类型"
    },
    domProps: {
      "value": (_vm.type)
    },
    on: {
      "input": function($event) {
        _vm.type = $event
      }
    }
  }, _vm._l((_vm.inputTypes), function(option) {
    return (!option.disabled) ? _c('el-option', {
      attrs: {
        "label": option.name,
        "value": option
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addInput
    }
  }, [_vm._v("添加")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left-table"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "70px"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.default.title))])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "类型"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.getTypeName(scope.row.default.type)))])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "300"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "default",
            "disabled": scope.$index == 0
          },
          on: {
            "click": function($event) {
              _vm.sortUp(scope.$index)
            }
          }
        }, [_vm._v("上移")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "default",
            "disabled": scope.$index == _vm.data.length - 1
          },
          on: {
            "click": function($event) {
              _vm.sortDown(scope.$index)
            }
          }
        }, [_vm._v("下移")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "default"
          },
          on: {
            "click": function($event) {
              _vm.setCurInput(scope.row, scope.$index)
            }
          }
        }, [_vm._v("配置")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "default"
          },
          on: {
            "click": function($event) {
              _vm.deleteInput(scope.$index)
            }
          }
        }, [_vm._v("删除")])])]
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "m-t-10"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.post()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.goback()
      }
    }
  }, [_vm._v("返回")])])]), _vm._v(" "), _c('input-config', {
    staticClass: "m-l-10",
    attrs: {
      "curInput": _vm.curInput,
      "inputList": _vm.data,
      "width": "42%",
      "showName": false
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8783a926!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/instance/paramsRender.vue
// module id = 1952
// module chunks = 2